exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".user-panel .img-circle{\n  min-height: 45px;\n}", "", {"version":3,"sources":["C:/Users/andco/Desktop/al/src/components/Sidebar/UserPanel.css"],"names":[],"mappings":"AAAA;EACE,iBAAgB;CAClB","file":"UserPanel.css","sourcesContent":[".user-panel .img-circle{\n  min-height: 45px;\n}"],"sourceRoot":""}]);

// exports
